export const hint = ({ theme: { colors } }) => ({
    position: 'absolute',
    fontSize: '0.75rem',
    left: '1.125rem',
    bottom: '-1.5rem',
    color: colors.lightGrey,
});
